import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "../firebase";

const UserContext = createContext();

export const createAuthUserForBulk = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});

  const createAuthUser = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    return signOut(auth);
  };

  const sendPasswordReset = (email) => {
    sendPasswordResetEmail(auth, email)
      .then(() => {
        console.log(`Email sent to ${email}`);
        // ..
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        createAuthUser,
        authUser: user,
        logout,
        signIn,
        sendPasswordReset,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
